// @flow
// react
import React, { useState } from "react";
import Spinner from "../components/Spinner";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "./ConfirmationModal";
import HiddenValue from "./HiddenValue";
import Restricted from "../helpers/permission/Restricted";
import { useSelector } from "react-redux";
import { getCurrentUser } from "aws-amplify/auth";
import { deleteDocument, getDocumentURL } from "../helpers/api/document";
import DocumentPreviewModal, {
  canPreviewDocument,
} from "./DocumentPreviewModal";
const DocumentItem = (props) => {
  console.log("DocumentItem: ", props.document);
  const { t } = useTranslation(["components", "common"]);
  const [docLoading, setDocLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // used for the remove document modal
  const [previewDoc, setPreviewDoc] = useState(null);
  const [confirmationModalLoading, setConfirmationModalLoading] =
    useState(false); // used for the remove document modal
  const { user } = useSelector((state) => ({
    user: state.Auth.user,
  }));
  let currentUser;
  if (typeof getCurrentUser === "function") {
    try {
      getCurrentUser()
        ?.then?.((user) => {
          currentUser = user;
        })
        ?.catch?.(() => {});
    } catch {}
  }

  console.log("DOCUMENT: ", props.document);

  const confirmModalHandler = async () => {
    setConfirmationModalLoading(true);
    try {
      await deleteDocument(props.document.id);
      toast.success(t("Deleted file: {{name}}", { name: props.document.name }));
      props.removeDocumentHandler({ id: props.document.id });
      setShowModal(false);
    } catch (error) {
      console.error("Error", error);
      toast.error(
        error?.message ||
          t("An error occurred while deleting the file. Please try again."),
      );
    } finally {
      setConfirmationModalLoading(false);
    }
  };

  const triggerDownload = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = () => {
    if (docLoading || props.disabled) return;
    setDocLoading(true);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    getDocumentURL(props.document.id, {
      userCountry: user?.country,
      compressed: props.compressed,
    })
      .then((url) => {
        setDocLoading(false);
        triggerDownload(url, props.document.name);
      })
      .catch((error) => {
        console.log("error", error);
        setDocLoading(false);
        toast.error(
          t(
            "The document couldn't be downloaded. Please refresh the page and try again."
          )
        );
      });
  };

  return (
    <React.Fragment>
      <Restricted
        to={`document.${props.collectionName}.${props.document.type}.read`}
      >
        <DocumentPreviewModal
          document={previewDoc}
          onHide={() => setPreviewDoc(null)}
          options={{ compressed: props.compressed }}
        />
        <ConfirmationModal
          showModal={showModal}
          hideModal={() => setShowModal(false)}
          title={t("Delete Document")}
          message={t("Are you sure that you want to delete this document?")}
          confirmButtonText={t("Delete")}
          confirmButtonLoading={confirmationModalLoading}
          cancelButtonText={t("Cancel")}
          confirmHandler={confirmModalHandler}
        />

        <div
          target="_blank"
          rel="noreferrer"
          title={
            !props.hidePreview && canPreviewDocument(props.document)
              ? t("Show Preview")
              : t("Download")
          }
          style={props.style}
          className={props.className}
          onClick={() => {
            if (props.disabled) return;
            // ponytail: Klick auf den Namen zeigt die Vorschau, wenn der Typ das hergibt
            // und der Aufrufer Vorschau nicht explizit unterdrueckt (z. B. SalesOffersDetails).
            if (!props.hidePreview && canPreviewDocument(props.document)) {
              setPreviewDoc(props.document);
              return;
            }
            handleDownload();
          }}
        >
          {/* Privacy Mode: the link text is a file name, so it belongs to the `documents` class.
              Both branches are wrapped — `linkName` is usually just a shortened version of the
              same file name, passed in by the caller. Callers that pass something else (a label
              like "Download") get bullets for it too, which is the safe direction to err in. */}
          <HiddenValue dataClass="documents">
            {props.linkName
              ? props.hideLinkNameWhileSpinner
                ? !docLoading && props.linkName
                : props.linkName
              : props.hideLinkNameWhileSpinner
                ? !docLoading && props.document.name
                : props.document.name}
          </HiddenValue>
          {docLoading && (
            <Spinner
              className="spinner-border-sm"
              tag="span"
              color={props.spinnerColor}
            />
          )}
        </div>
        {/* ponytail: span statt button — diese Komponente steckt an einer Stelle
            (SalesOffersDetails) selbst in einem <Button>, und ein button im button
            ist ungueltiges HTML. `hidePreview` fuer Aufrufer, die die Vorschau als
            eigenen Knopf danebenstellen (SalesOffersDetails). */}
        {!props.hidePreview && canPreviewDocument(props.document) && (
          <span
            role="button"
            className="text-muted ms-1"
            title={t("Show Preview")}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setPreviewDoc(props.document);
            }}
          >
            <i className="mdi mdi-file-eye-outline"></i>
          </span>
        )}
        {!props.hidePreview && (
          <span
            role="button"
            className={`text-muted ms-1 ${props.disabled ? "disabled" : ""}`}
            title={t("Download")}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleDownload();
            }}
          >
            <i className="dripicons-download"></i>
          </span>
        )}
      </Restricted>
    </React.Fragment>
  );
};

export default DocumentItem;
